import Layout from "../../Internal/Layout.vue";
import CommonQuestions from "./CommonQuestions.vue";
import CommonQuestionsRegister from "./components/CommonQuestionsRegister.vue";
import CommonQuestionsResale from "./components/CommonQuestionsResale";

const CommonQuestionsRoutes = {
  component: Layout,
  children: [
    {
      path: "/perguntasFrequentesAdmin",
      name: "CommonQuestions",
      component: CommonQuestions,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
    },
    {
      path: "/perguntasFrequentesCadastrar",
      name: "CommonQuestionsRegister",
      component: CommonQuestionsRegister,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
      },
    },
    {
      path: "/perguntasFrequentes",
      name: "CommonQuestionsResale",
      component: CommonQuestionsResale,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresManagerial: true,
        requiresResale: true,
      },
    },
  ],
};

export default CommonQuestionsRoutes;
